import ArrowBack from "@mui/icons-material/ArrowBack";
import { Button, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { type FC, useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { AutoAwesomeColouredOutlined } from "../../../styles/icons/auto-awesome-coloured-outlined";

type SurveyAlertWizardStep5Values = {
  content_prompt: string;
};

type SurveyAlertWizardStep5Props = {
  onBack: () => void;
  onCompleteChange: (complete: boolean) => void;
};

export const SurveyAlertWizardStep5: FC<SurveyAlertWizardStep5Props> = ({
  onBack,
  onCompleteChange,
}) => {
  const { control } = useFormContext<SurveyAlertWizardStep5Values>();

  useEffect(() => {
    onCompleteChange(true);
  }, [onCompleteChange]);

  return (
    <>
      <DialogTitle>
        <Stack spacing={1} alignItems="flex-start">
          <Button
            startIcon={<ArrowBack />}
            onClick={onBack}
            data-analytics-id="survey-alert-wizard-back"
          >
            Back
          </Button>
          <Stack direction="row" spacing={1} alignItems="center">
            <AutoAwesomeColouredOutlined />
            <Typography variant="h6" component="span">
              Generate notification text with AI
            </Typography>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={4}>
          <Stack spacing={0.5}>
            <Typography>
              Enter a prompt to generate the text in your notification Communication (optional). You
              can edit the text before publishing your notification. If you’ve already added text to
              your Communication, it will be replaced.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Text generated using AI. Please check content for accuracy, AI can make mistakes.
            </Typography>
          </Stack>
          <Controller
            name="content_prompt"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                multiline
                minRows={4}
                placeholder="Prompt (optional)"
                slotProps={{ htmlInput: { "aria-label": "Prompt (optional)" } }}
              />
            )}
          />
        </Stack>
      </DialogContent>
    </>
  );
};
